import { useTranslation } from 'react-i18next';

import { NotificationItemProps } from 'types/api/notification.type';

import { NotificationItem } from 'pages/Catalogue/components/NotificationItem/NotificationItem';

import { Modal } from 'components/Modal';

import * as S from './NotificationModal.styles';

type NotificationModalProps = {
  onClose: () => void;
  data?: NotificationItemProps[];
};

export function NotificationModal(props: NotificationModalProps): React.ReactElement {
  const { onClose, data } = props;

  const { t } = useTranslation();

  return (
    <Modal onClose={onClose}>
      <S.Title scale="xl3">{t('notification.relatedNotifications')}</S.Title>
      <S.Content>
        {data?.map((item) => (
          <NotificationItem key={item.id} {...item} />
        ))}
      </S.Content>
    </Modal>
  );
}
